import styled from 'styled-components';
import { font } from 'styles/globals';
import Heading from 'styles/typography/Heading';
import { breakpoint } from 'styles/globals';
import { getColor } from 'styles/theme';
import type { ThemeProps } from 'styles/theme/types';

export const Container = styled.div`
  gap: 16px;
  .image-link {
    aspect-ratio: 3 / 2;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;

  @media (${breakpoint.mdMin}) {
    .child-content {
      flex: 1;
    }
  }

  @media (min-width: 1025px) {
    flex-direction: row;
    gap: 32px;
  }
`;
export const Title = styled(Heading)``;

export const DescriptionWrapper = styled.p<{ theme: ThemeProps }>`
    font-family: ${font.graphikCond};
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; 
    letter-spacing: 0.5px;

    a {
        color: ${getColor('textLink')};

        &:hover {
            color: ${getColor('textSecondary')};
        }
    }
`;
